<div class="d-flex flex-grow-1 w-100">
    <div class="selection-form d-flex flex-column pe-4">
        @if (gridApi) {
            <form [formGroup]="form" class="d-flex flex-column gap-2">
                <div class="mb-2">
                    <label class="form-label" for="outputFormat">Output Format</label>
                    <ws-select formControlName="outputFormat"
                               data-qa="bundler-output-format"
                               placeholder="Select"
                               [options]="outputFormatOptions"
                               labelProperty="name"
                               valueProperty="value">
                    </ws-select>
                </div>
                @if (showZipForm) {
                    <div class="mb-2">
                        <div class="file-name-preview-label">
                            <label class="form-label mb-0" for="fileNamingConvention">File Naming Convention</label>
                            <button type="button"
                                    class="file-name-preview-info"
                                    data-qa="bundler-file-name-preview"
                                    [popover]="fileNamingPreviewPopover"
                                    triggers="mouseenter:mouseleave click"
                                    container="body"
                                    containerClass="bundler-file-name-preview-popover"
                                    placement="right"
                                    aria-label="Show file naming preview">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                            </button>
                        </div>
                        <ng-template #fileNamingPreviewPopover>
                            @if (hasFileNamePreview) {
                                <div class="d-flex align-items-center flex-nowrap file-name-preview-content">
                                    @for (column of fileNamePreviewSegments; track column; let last = $last) {
                                        <div class="file-name-format">{{ column }}</div>
                                        @if (!last) {
                                            <div>-</div>
                                        }
                                    }
                                </div>
                            } @else {
                                <span>{{ emptyFileNamePreviewText }}</span>
                            }
                        </ng-template>
                        <ws-picklist [options]="fileNameColumns"
                                     data-qa="bundler-naming-convention"
                                     labelProperty="name"
                                     placeholder="Please select additional columns..."
                                     [canReorganize]="true"
                                     [returnEntireOption]="true"
                                     [mustHaveOne]="true"
                                     formControlName="namingConvention">
                        </ws-picklist>

                        @if (hasDuplicateNames) {
                            <div class="warning-message mt-1 px-2 py-1">
                                <span class="warning-message-legend" aria-hidden="true"></span>
                                <span>Non-unique file names have been suffixed with an incrementing number in parentheses.</span>
                            </div>
                        }
                        @if (hasTruncatedNames) {
                            <div class="warning-message mt-1 px-2 py-1">
                                <span class="warning-message-legend" aria-hidden="true"></span>
                                <span>One or more file names were truncated to 255 characters.</span>
                            </div>
                        }
                        @if (hasOverlongNames) {
                            <div class="warning-message mt-1 px-2 py-1">
                                <span class="warning-message-legend" aria-hidden="true"></span>
                                <span>One or more file names exceed 100 characters; you may need to use 7-zip to extract the attachments</span>
                            </div>
                        }
                    </div>
                    <div class="mb-2">
                        <div class="checkbox">
                            <label for="includeManifest">
                                <input type="checkbox"
                                       id="includeManifest"
                                       class="checkbox"
                                       data-qa="bundler-include-manifest"
                                       formControlName="includeManifest" />
                                Include Manifest
                            </label>
                        </div>
                    </div>
                }
            </form>
        }
    </div>
    <div class="selection-grid d-flex flex-column flex-grow-1 ps-4">
        <h4>
            Attachments
            <ag-grid-row-count [gridApi]="gridApi"
                               [gridOptions]="gridOptions">
            </ag-grid-row-count>
        </h4>
        <div class="d-flex flex-grow-1 w-100">
            <ws-ag-grid-angular [gridOptions]="gridOptions"
                                [defaultSizeToContent]="true"
                                [forceShowToolPanel]="true"
                                [showFilter]="false"
                                (gridReady)="onAgGridReady($event)">
            </ws-ag-grid-angular>
        </div>
    </div>
</div>
